<!-- 常量管理 -->
<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ basicClassify.Name+'('+basicClassify.Code+')' }}</el-tag>
    </div>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增常量
      </el-button>
    </div>
    <el-table
      ref="multipleTable"
      size="medium"
      :data="itemList"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="常量名称"></el-table-column>
      <el-table-column
        prop="Type"
        label="常量编码"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="SpeNb"
        label="常量值"
        width="200"
      ></el-table-column>
      <el-table-column prop="Sort" label="排序值" width="200"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="200"></el-table-column>
      <el-table-column width="160" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :isEdit="isEdit"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./data--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      isEdit: false,
      basicClassify: [],
    };
  },
  mounted() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      this.$axios
        .get(`basicclassify/${this.$route.params.ID}`)
        .then((response) => {
          this.basicClassify = response.data;
          this.getItemList();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getItemList() {
      //获取常量列表
      this.loading = true;
      this.$axios
        .get("basic", {
          params: {
            where: { BasicClassifyID: this.basicClassify.ID },
            with: ["BasicClassify"],
            ...this.pager,
            order: ["-sort", "name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.item.BasicClassifyID = this.basicClassify.ID;
      this.isEdit = false;
      this.itemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.isEdit = true;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除该常量吗？", "提示")
        .then(() => this.$axios.delete(`basic/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        Name: "", //常量名称
        Type: "", //常量编码
        SpeNb: "", //常量值
        BasicClassifyID: null, //常量分类id
        Sort: 0, //排序
        Remark: "", //备注
      };
    },
  },
};
</script>
